// CheckboxSelector.jsx
import './CheckboxSelector.css';
import Checkbox from "@mui/material/Checkbox";

const SPECIAL_MAP = {
    'Bestsellery': 'bestseller',
    'Nowa kolekcja': 'newcollection',
    'Promocje': 'promotion',
};

// Normalizacja nagłówka grupy -> klucz w stanie
function normParentLabel(parentLabel) {
    const p = (parentLabel || '').toLowerCase().trim();
    if (p === 'marka' || p === 'marki') return 'marka';
    if (p === 'kategoria' || p === 'kategorie') return 'kategoria';
    if (p === 'oferty specjalne') return 'oferty';
    return p; // fallback
}

export default function CheckboxSelector({ label, parentLabel, filters, setFilters }) {
    const checked = getChecked(filters, label, parentLabel);

    const onChange = (e) => {
        manageFilters(setFilters, label, parentLabel, e.target.checked);
    };

    return (
        <div className='checkbox-selector'>
            <Checkbox
                checked={checked}
                onChange={onChange}
                sx={{
                    color: "rgba(58, 14, 27, 0.6);", // unchecked border color

                    "&.Mui-checked": {
                        color: "#3A0E1B", // checked fill & checkmark
                    },
                    "& .MuiTouchRipple-root": { display: "none" },

                }}
            />

            <span className='checkbox-selector-label'>{label}</span>
        </div>
    );
}

function getChecked(filters, label, parentLabel) {
    const group = normParentLabel(parentLabel);
    if (group === 'marka')     return filters.marka?.includes(label);
    if (group === 'kategoria') return filters.kategoria?.includes(label);
    if (group === 'oferty') {
        const key = SPECIAL_MAP[label];
        return key ? Boolean(filters[key]) : false;
    }
    return false;
}

function manageFilters(setFilters, element, parentLabel, isChecked) {
    const group = normParentLabel(parentLabel);

    setFilters(prev => {
        if (group === 'marka' || group === 'kategoria') {
            const key = group; // 'marka' | 'kategoria'
            const next = new Set(prev[key] || []);
            if (isChecked) next.add(element); else next.delete(element);
            return { ...prev, [key]: [...next] };
        }

        if (group === 'oferty') {
            const key = SPECIAL_MAP[element]; // 'bestseller' | 'newcollection' | 'promotion'
            if (!key) return prev;
            return { ...prev, [key]: Boolean(isChecked) };
        }

        return prev;
    });
}
